export { default as PatientListTemplate } from './PatientList';
export { default as PatientPreviewTemplate } from './PatientPreview';
export { default as PatientSalesOrderListTemplate } from './PatientSalesOrderList';
export { default as PatientTemplateListTemplate } from './PatientTemplateList';
export { default as SalesOrderPreviewTemplate } from './SalesOrderPreview';
export { default as TemplatePreviewTemplate } from './TemplatePreview';